import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackBiometricsToggle = (isEnabled: boolean) => {
  trackEvent(keys.biometricsTogglePressed, { isEnabled })
}
